import { AxiosAPI } from '@/axios';

export default {
  generate ({ prompt, subject, documentTypeId }, token, signal) {
    return AxiosAPI.post('api/documents/generate', {
      prompt,
      subject,
      document_type_id: documentTypeId || null
    }, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      },
      signal
    });
  },
  refineSelection ({ selectionHtml, documentHtml, instruction, previousSuggestions }, token, signal) {
    return AxiosAPI.post('api/documents/generate/refine-selection', {
      selection_html: selectionHtml,
      document_html: documentHtml,
      instruction,
      previous_suggestions: previousSuggestions
    }, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      },
      signal
    });
  }
};
